var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBubbleBlack = function SvgBubbleBlack(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 306.23,
    height: 240.92,
    viewBox: "0 0 306.23 240.92",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h306.23v240.92H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    overflow: "visible"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#020101",
    d: "M87.01 239.84c-.29-.63-1.23-1.4 2.62-4.41s19.17-18.95 4.45-35.73c-8.69-9.9-28.48-13.84-45.12-19-14.83-4.6-40.78-21.63-47.39-53.82C-8.05 79.98 25.33 16.13 130.36 2.23c73.21-9.69 134.04 12.64 161.4 59.47 26.84 45.93 16.24 104.43-31.11 137.55-32.52 22.74-68.8 27.25-114.37 25.23-4.99-.2-9.96-.76-14.86-1.69-1.93-.21-5.78-.86-9 3s-13.28 13.94-29.14 15.02c-3.42.34-5.85-.08-6.27-.97"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBubbleBlack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bubble-black.b6775ac3f1bc53ef3f7f171c8a709106.svg";